// removed by extract-text-webpack-plugin
module.exports = {"container":"_2Ds98"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/FeaturedFilter.less
// module id = ./src/components/Home/FeaturedFilter.less
// module chunks = 2